<template>
    <div class="wp">
        <div class="w-1200 home-list-1 m-b-10">
            <div class="title-more">
                <i class="el-icon-s-home" style="color:#615E61;position:relative;top:16px;left:10px;"> </i>
                <el-breadcrumb style="width:90%;padding-left:40px;"  separator=" - ">
                        <el-breadcrumb-item :to="{ path: '/information' }">资讯中心</el-breadcrumb-item>
                        <el-breadcrumb-item> {{breadTitle}}</el-breadcrumb-item>
                </el-breadcrumb>
            </div>
            <div class="home-list-content">
                <com-list :breadTitle="breadTitle" :list="list" @getDetail="getDetail"></com-list>
            </div>
            
            <z-page :pageObj="page" @changePage1="changePage"></z-page>
        </div>
    </div>
</template>
<script>
import InformationList from './InformationList.js';
export default InformationList;
</script>
<style lang="scss" scoped>
@import './InformationList.scss';
</style>